import BaseService from "./baseService";

class NotificationTopic extends BaseService {
  async getNotificationTopics(opts = {}) {
    this.endPoint = "/notification-topics";
    return this.get(opts);
  }
  async storeNotificationTopic(payload) {
    this.endPoint = "/notification-topics";
    return this.post(payload);
  }
  async updateNotificationTopic(id, payload, opts = {}) {
    this.endPoint = "/notification-topics";
    return this.putOne(id, payload, opts);
  }
  async deleteNotificationTopic(id, opts = {}) {
    this.endPoint = "/notification-topics";
    return this.delete(id, opts);
  }
}

export default new NotificationTopic();
